/* eslint-disable no-bitwise */
/* eslint-disable no-unused-vars */

const filters = () => {
  const form = document.querySelector('.js-filter-form');

  if (form) {
    let page = new URL(window.location).searchParams.get('filter_page');
    page = page ? page : 1;
    const button = document.querySelector('.js-lets-filter');
    const searchInputBtn = document.querySelector('.js-search-input-btn');
    const searchInputClear = document.querySelector('.js-search-input-clear');
    const searchInputText = document.querySelector('.js-filter-search-text');
    const loader = document.querySelector('.js-loader');
    const yearsAccept = document.querySelector('.js-years-ok');
    const switchers = document.querySelectorAll('.js-filters-button');
    const switchersContainer = document.querySelector('.js-filters-switchers');
    const filtersBody = document.querySelector('.js-filters-body');
    const filters = document.querySelector('.js-filters');
    const loop = document.querySelector('.loop');


    // Handle filters body switcher
    switchers.forEach(btn => {
      btn.addEventListener('click', event => {
        switchers.forEach(switcher => {
          switcher.classList.toggle('u-hidden');
        });
        filters.classList.toggle('is-expanded');
        filtersBody.classList.toggle('is-active');
        switchersContainer.classList.toggle('is-active');
      });
    });

    // clear cats
    document.addEventListener(
      'click',
      function (event) {
        // If the clicked element doesn't have the right selector, bail
        if (!event.target.matches('.js-clear-cats')) return;
        let inputs = event.target.parentNode.parentNode.parentNode.querySelectorAll(
          'input:checked',
        );

        inputs.forEach(input => {
          input.checked = false;
        });

        // Trigger filter button
        setTimeout(() => {
          button.click();
        }, 50);
      },
      false,
    );

    // clear years
    document.addEventListener(
      'click',
      function (event) {
        // If the clicked element doesn't have the right selector, bail
        if (!event.target.matches('.js-clear-years')) return;
        let inputs = event.target.parentNode.parentNode.parentNode.querySelectorAll(
          'input',
        );

        inputs.forEach(input => {
          input.value = null;
        });

        // Trigger filter button
        setTimeout(() => {
          button.click();
        }, 50);
      },
      false,
    );

    // clear cats
    document.addEventListener(
      'click',
      function (event) {
        // If the clicked element doesn't have the right selector, bail
        if (!event.target.matches('.js-pagination-trigger')) return;
        page = event.target.dataset.to;

        // Trigger filter button
        setTimeout(() => {
          button.click();
          loop.scrollIntoView();
        }, 50);
      },
      false,
    );

    // submit on check
    document.addEventListener(
      'change',
      function (event) {
        // If the clicked element doesn't have the right selector, bail
        if (!event.target.matches('.js-category')) return;

        // Trigger filter button
        setTimeout(() => {
          button.click();
        }, 50);
      },
      false,
    );

    // submit on ok
    yearsAccept.addEventListener('click', e => {
      e.preventDefault();
      button.click();
    });

    // submit on text change
    searchInputText.addEventListener('change', () => {
      button.click();
    });

    // clear text input
    const clearFormInput = () => {
      searchInputText.value = '';
      searchInputText.focus();
    };
    searchInputClear.addEventListener('click', clearFormInput);

    searchInputBtn.addEventListener('click', () => {
      button.click();
    });

    /**
     * send ajax
     */
    let newQueryAjax = e => {
      e.preventDefault();

      /**
       * Declare DOM objects
       */
      let searchText = document.querySelector('.js-filter-search-text');
      let dateMin = document.querySelector('.js-filter-date-min');
      let dateMax = document.querySelector('.js-filter-date-max');
      let selectedCategories = document.querySelectorAll(
        '.js-filter-categories input:checked',
      );
      let categories = [];
      let postType = document.querySelector('input[name="post_type"]').value;
      let taxonomy = document.querySelector('input[name="taxonomy"]').value;

      /**
       * Make them useful for ajax fn
       */
      searchText = searchText.value ? searchText.value : null;
      dateMin = dateMin.value ? dateMin.value : null;
      dateMax = dateMax.value ? dateMax.value : null;
      for (let i = 0; i < selectedCategories.length; i++) {
        categories = [...categories, selectedCategories[i].dataset.id];
      }

      /**
       * gather all data and parse it to url query
       */
      let formData = {
        filter_categories: categories,
        filter_date_min: dateMin,
        filter_date_max: dateMax,
        filter_search_text: searchText,
        filter_page: page,
      }

      let ajaxData = {
        action: 'publications_filtration',
        filter_post_type: postType,
        filter_taxonomy: taxonomy,
        ...formData
      };

      let ajaxParameters = Object.entries(ajaxData)
        .map(e => e.join('='))
        .join('&');

      let url = new URL(window.location);
      Object.entries(formData).forEach(param => {
        if (!!param[1]) {
          url.searchParams.set(param[0], param[1]);
          window.history.pushState({}, '', url);
        }
      });

      /**
       * Ajax post
       */
      const ajax_url = document.querySelector('meta[name="ajax_url"]').content;
      let request = new XMLHttpRequest();
      request.open('POST', ajax_url, true);
      request.setRequestHeader(
        'Content-Type',
        'application/x-www-form-urlencoded;',
      );
      request.onload = function () {
        if (this.status >= 200 && this.status < 400) {
          loader.classList.add('u-fade-in');
          loader.classList.remove('u-hidden');
          setTimeout(() => {
            document.querySelector('.loop').innerHTML = this.response;

            setTimeout(() => {
              loader.classList.remove('u-fade-in');
              loader.classList.add('is-fading-out');
              setTimeout(() => {
                loader.classList.remove('is-fading-out');
                loader.classList.add('u-hidden');
              }, 240);
            }, 150);
          }, 240);
        } else {
          // If fail
          console.log(this.response);
        }
      };
      request.onerror = function () {
        // Connection error
      };
      request.send(ajaxParameters);
    };

    /**
     * Listeners
     */
    form.addEventListener('submit', newQueryAjax);


    /**
     * Fill filters according to url queries
     */
    const fillFilters = () => {
      const url = new URL(window.location);
      const params = url.searchParams;
      if (params) {
        searchInputText.value = params.get('filter_search_text');
        document.querySelector('.js-filter-date-min').value = params.get('filter_date_min');
        document.querySelector('.js-filter-date-max').value = params.get('filter_date_max');
        let categories = params.get('filter_categories');
        if (categories && document.querySelector(`input[name="cat_all"]`)) {
          categories = categories.split(',');
          categories.forEach(id => {
            document.querySelector(`input[name="cat_${id}"]`).checked = 'checked';
          });
        }
        if (document.querySelector(`input[name="cat_all"]`)) {
          document.querySelector(`input[name="cat_all"]`).checked = 'checked';
        }
        button.click();
      } else {
        document.querySelector(`input[name="cat_all"]`).checked = 'checked';
        button.click();
      }
    }
    fillFilters();
  }

};

export default filters;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/eco-chisel/src/scripts/modules/filters.js